import React from "react";
import { motion } from "framer-motion";
import {
  FlaskConical,
  UserRound,
  ShieldCheck,
  Globe2,
  LineChart,
  Crown,
} from "lucide-react";
import { useLang } from "../i18n/LangContext";

const ICONS = [FlaskConical, UserRound, ShieldCheck, Globe2, LineChart, Crown];

export const Trust = () => {
  const { t } = useLang();
  const items = t("trust.items");

  return (
    <section
      id="warum"
      data-testid="section-trust"
      className="relative py-24 lg:py-32 bg-black overflow-hidden"
    >
      <div className="mx-auto max-w-[1400px] px-6 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 mb-16 lg:mb-24">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3 mb-6">
              <span className="h-px w-10 bg-primary-red" />
              <span className="text-[10px] sm:text-xs font-bold uppercase tracking-[0.28em] text-zinc-400">
                {t("trust.eyebrow")}
              </span>
            </div>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold text-white leading-[1.05] tracking-tight">
              {t("trust.title")}
            </h2>
          </div>
          <div className="lg:col-span-6 lg:col-start-7 flex items-end">
            <p className="font-body text-base lg:text-lg text-zinc-400 leading-relaxed">
              {t("trust.subtitle")}
            </p>
          </div>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-white/5 border border-white/5">
          {items.map((it, i) => {
            const Icon = ICONS[i % ICONS.length];
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.6, delay: i * 0.06, ease: [0.16, 1, 0.3, 1] }}
                className="group relative bg-[#080808] p-8 lg:p-10 hover:bg-[#0f0f0f] transition-colors duration-500"
                data-testid={`trust-item-${i}`}
              >
                <div className="flex items-start justify-between mb-8">
                  <div className="w-12 h-12 rounded-full border border-white/10 flex items-center justify-center group-hover:border-primary-red transition-colors">
                    <Icon
                      size={20}
                      className="text-zinc-300 group-hover:text-primary-red transition-colors"
                    />
                  </div>
                  <span className="text-[10px] font-bold text-zinc-600 tracking-widest">
                    0{i + 1}
                  </span>
                </div>
                <h3 className="font-display text-xl lg:text-2xl font-semibold text-white mb-3 tracking-tight">
                  {it.title}
                </h3>
                <p className="font-body text-sm text-zinc-500 leading-relaxed">
                  {it.desc}
                </p>
                <div className="absolute bottom-0 left-0 h-px w-0 bg-primary-red group-hover:w-full transition-all duration-700" />
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
